/**
 * SSOT Application Configuration.
 * All environment-specific values live here.
 */
export const AppConfig = {
  /** Base URL for the link shortener / share site */
  shareBaseUrl: 'https://bitdrop.site',
  
  /** App scheme for deep linking */
  appScheme: 'bitdrop',
  
  /** iOS Universal Links domain */
  universalLinkDomain: 'bitdrop.site',
  
  /** Android App Links domain */
  appLinkDomain: 'bitdrop.site',
} as const;
